import { LogLevel, } from "./Logging-types";
import { datadogLogs } from "@datadog/browser-logs";
/**
 * Log events to Datadog
 * @param msg
 * @param payload
 */
export const datadogLog = (env, build, application) => (msg, type, messageContext, error) => {
    const contextWithEnvData = Object.assign(Object.assign({}, messageContext), { environment: env, build_number: build, application: application });
    switch (type) {
        case LogLevel.INFO:
            datadogLogs.logger.info(msg, contextWithEnvData, error);
            break;
        case LogLevel.DEBUG:
            datadogLogs.logger.debug(msg, contextWithEnvData, error);
            break;
        case LogLevel.WARN:
            datadogLogs.logger.warn(msg, contextWithEnvData, error);
            break;
        case LogLevel.ERROR:
            datadogLogs.logger.error(msg, contextWithEnvData, error);
            break;
    }
};
/**
 * This function configures the DataDog SDK with the provided parameters,
 * setting up the necessary environment, versioning, and service identification
 * for effective logging.
 *
 * @param {string} token - The client token provided by DataDog for authentication.
 * @param {string} environment - The current application environment (e.g., production, development).
 * @param {string} build - The build version of the application.
 * @param {string} applicationName - The name of the application or service.
 */
export const datadogInit = (token, environment, build, applicationName) => {
    datadogLogs.init({
        clientToken: token,
        env: environment,
        version: build,
        service: applicationName,
    });
};
